interface InlineErrorBannerProps {
  message: string;
  'data-testid'?: string;
}

/**
 * Shared inline error banner for surfacing actionable errors directly in forms.
 *
 * Extracted from the inline pattern in CameraPhotoUpload (where it was only used
 * for failed upload filenames). Now used across 4+ consumers:
 * - HarvestFormPage (photo attachment failure)
 * - LogEntryFormPage (photo attachment failure)
 * - HuntDetailPage (sit photo attachment failure)
 * - CameraPhotoUpload (upload failure list — migrated to use this component)
 */
export function InlineErrorBanner({
  message,
  'data-testid': testId,
}: InlineErrorBannerProps) {
  return (
    <div
      role="alert"
      data-testid={testId ?? 'inline-error-banner'}
      className="px-3 py-2 rounded-lg bg-red-900/20 border border-red-700/40 text-body-xs text-red-300"
    >
      {message}
    </div>
  );
}
